import type { RouterOutputs } from "@repo/api";
import { formatIntToCurrency } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import type { ColumnDefWithTotal } from "~/types";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { api } from "~/lib/api";
import { useReportStore } from "~/stores/use-report-store";

export const Route = createFileRoute("/_main/reports/_layout/vat")({
  component: VatReportPage,
});

type Report = RouterOutputs["report"]["getVATReport"][number];

function VatReportPage() {
  const { t } = useTranslation("common");
  const { range } = useReportStore();

  const { data: reportData } = api.report.getVATReport.useQuery({
    start: range.from,
    end: range.to,
  });

  const columns: ColumnDefWithTotal<Report>[] = [
    {
      id: t("Report.vat_rate_name"),
      accessorKey: "",
      filterFn: "includesString",
      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Report.vat_rate_name")}
        />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{report.vatRateName}</p>;
      },
    },
    {
      id: t("Report.vat_rate"),
      accessorKey: "",
      filterFn: "includesString",
      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("Report.vat_rate")} />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{report.vatRate}</p>;
      },
    },
    {
      id: t("Report.revenue"),
      accessorKey: "",
      filterFn: "includesString",
      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("Report.revenue")} />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{formatIntToCurrency(report.revenue)}</p>;
      },
    },
    {
      id: t("Report.vat"),
      accessorKey: "",
      filterFn: "includesString",
      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("Report.vat")} />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{formatIntToCurrency(report.vat)}</p>;
      },
    },
  ];
  return (
    <DataTable
      defaultSorting={[{ id: t("Report.vat_rate"), desc: false }]}
      pdfExport={{
        filename: "day-report",
      }}
      csvExport={{
        filename: "day-report",
      }}
      columns={columns}
      data={reportData ?? []}
    />
  );
}
